import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { Row, Col } from '../../atoms/Grid'

import PlaceHolder from '../../atoms/PlaceHolder'
import ShareBar from '../../molecules/ShareBar'
import Avatar from '../../atoms/Avatar'
import { dateFormat } from '../../helpers/Formatter'
import Comments from '../../organisms/Comments'
import T from '../../translate/T'

import { byToken } from '../../utils/timeline'

import style from './style.css'

class Article extends Component {
   constructor(props) {
      super(props)

      this.state = {
         status: "loading"
      }
   }

   componentWillMount() {
      if(!this.props.token) {
         this.props.notFound()
      } else {
         byToken(this.props.token)
         .then(resp => {
            if(resp.errors) {
               this.props.notFound()
            } else {  
               if(resp.post_type === 'article')
               resp.content = JSON.parse(resp.content)
               
               this.setState({
                  status: "done",
                  article: resp
               })
            }
            
         })
      }
   }

   LoadingContent() {
      return (
         <Row>
            <Col size='12 10' float='center'>
               <Row>
                  <Col size={`8`}>
                     <PlaceHolder style={{ height: "35px", marginBottom: '30px' }} type="retangle" />
                  </Col>
                  <Col size={`12`}>
                     <PlaceHolder style={{ height: "250px", marginBottom: '20px' }} type="retangle" />
                     <PlaceHolder style={{ height: "25px", marginBottom: '20px' }} type="retangle" />
                     <PlaceHolder style={{ height: "25px", marginBottom: '20px' }} type="retangle" />
                     <PlaceHolder style={{ height: "25px", marginBottom: '20px' }} type="retangle" />
                  </Col>
               </Row>
            </Col>
         </Row>
      )
   }

   render() {
      return (
         <div>
            {this.state.status === 'loading' && (
               <this.LoadingContent />
            )}
            
            {this.state.status === 'done' && (
               <div>
                  <Row>
                     <Col size='12 10' float='center'>
                        <h1 className={style.title}>{this.state.article.content.title}</h1>
                        <div className={style.author}>
                           <Avatar img={window.URL_ASSETS_BASE+this.state.article.user_avatar} href={"link user"} size={40} />
                           <div className={style.userdata}>
                              {this.state.article.user_name} <br />
                              <div className={style.data}>
                                 {dateFormat(T.txt('c_format_date'), this.state.article.published_at)}
                              </div>
                           </div>
                        </div>
                        <div className={style.content} dangerouslySetInnerHTML={{__html: this.state.article.long_content}} />
                     </Col>
                  </Row>
                  
                  <Row>
                     <Col size='12 10' float='center'>
                        <ShareBar />
                     </Col>
                  </Row>

                  <Row>
                     <Col size='12 10' float='center'>
                        <h2>Comentários</h2>
                        <Comments isLogged={this.props.isLogged} user={this.props.userData} id={this.state.article.id} />
                     </Col>
                  </Row>

                  {this.state.status === 'done' && (
                     <Helmet>
                        <title>SPRINTA | {this.state.article.content.title}</title>
                        <meta property="og:locale" content='pt-BR'/>
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:title" content={this.state.article.content.title}/>
                        <meta property="og:description" content={this.state.article.content.content}/>
                        <meta property="og:image" content={ this.state.article.image2 ? this.state.article.image : window.URL_ASSETS_BASE+this.state.article.user_avatar } />
                     </Helmet>
                  )}
               </div>
            )}
         </div>
      )
   }
}

export default Article


// WEBPACK FOOTER //
// ./src/SPRINTA/organisms/Article/index.js